<template>
    <label :class="{'switch':true, 'on':on}">
        <input type="checkbox" v-model="on" />
        <span class="slider round"></span>
        <span class="text">{{ on ? onLabel : offLabel }}</span>
    </label>
</template>

<script>
export default {
    props: {
        value: [Boolean],
        onLabel: {
            type: String,
            default: 'ON',
        },
        offLabel: {
            type: String,
            default: 'OFF',
        }
    },
    data: function() {
        return {
            on: this.value || false,
        }
    },
    watch: {
        value: function(value) {
            this.on = value;
        },
        on: function(newValue) {
            this.$emit('input', newValue);
        }
    }
}
</script>

<style lang="scss" scoped>
/* The switch - the box around the slider */
.switch {
    cursor: pointer;
    display: inline-block;
    height: 24px;
    margin: 0;
    position: relative;
    vertical-align: middle;
    width: 48px;
  }
  
    /* Hide default HTML checkbox */
    .switch input {
        display:none;
    }
  
    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #DDD;
        -webkit-transition: .4s;
        transition: .4s;
    }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: var(--primary);
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px var(--primary);
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
  
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }

  .text {
      color: #8D8D8D;
      font-size: 10px;
      font-family: sans-serif;
      line-height: 24px;
      position: absolute;
      right: 4px;
      text-align: center;
      width: 20px;
  }

  .on .text {
      color: #FFF;
      left: 4px;
  }
</style>